export const environment = {
    production: false,
    hmr: false,
    api: 'https://schedule.staging.agendaodonto.com/',
};
